import { render, staticRenderFns } from "./HeaderIcon.vue?vue&type=template&id=5adfc6bf&scoped=true"
import script from "./HeaderIcon.vue?vue&type=script&lang=js"
export * from "./HeaderIcon.vue?vue&type=script&lang=js"
import style0 from "./HeaderIcon.vue?vue&type=style&index=0&id=5adfc6bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adfc6bf",
  null
  
)

export default component.exports